export const DESELECT_BUS_SEAT = 'BUS/DESELECT_BUS_SEAT';

export default function deselectBusSeat(wagonId, seat) {
  return {
    type: DESELECT_BUS_SEAT,
    payload: { wagonId, seat },
  };
}
